/* lib/api/kitchen.js — карточки «Кухни»/сырьё (порт из frontend/src/lib/api/kitchen.js, 1:1).
 * Контракт apiFetch {ok,status,data}. Адаптация формы под UI — в lib/adapters/ingredients.js. */
import { apiFetch } from './client.js';

export const listCards = (params = {}) => {
  const query = new URLSearchParams();
  if (params.type) query.set('type', params.type);
  if (params.q) query.set('q', params.q);
  if (params.archived) query.set('archived', '1');
  const qs = query.toString();
  return apiFetch(`/api/kitchen/cards/${qs ? `?${qs}` : ''}`);
};

export const getCard = (id) => apiFetch(`/api/kitchen/cards/${id}/`);
export const getCardUsedIn = (id) => apiFetch(`/api/kitchen/cards/${id}/used-in/`);

export const updateCard = (id, body) =>
  apiFetch(`/api/kitchen/cards/${id}/`, { method: 'PATCH', body });
export const deleteCard = (id) =>
  apiFetch(`/api/kitchen/cards/${id}/`, { method: 'DELETE' });
// F41 — массовое удаление сырья (multi-select). Используемые в ТТК — в skipped.
export const bulkDeleteCards = (ids) =>
  apiFetch('/api/kitchen/cards/bulk-delete/', { method: 'POST', body: { ids } });
export const createCard = (payload) =>
  apiFetch('/api/kitchen/cards/', { method: 'POST', body: payload });

// Точечная LLM-оценка КБЖУ по имени (+опц. категория) — кнопка «Заполнить через AI»
// в редакторе карточки. → {kcal,protein,fat,carbs,allergens}.
export const estimateKbju = (name, category) =>
  apiFetch('/api/kitchen/cards/estimate-kbju/', {
    method: 'POST', body: { name, category: category || null },
  });

export const CARD_TYPES = [
  { slug: 'ingredient', label: 'Ингредиенты' },
  { slug: 'semiproduct_bought', label: 'Полуфабрикаты закупаемые' },
];
export const CARD_TYPE_LABEL = Object.fromEntries(CARD_TYPES.map((t) => [t.slug, t.label]));
